module.exports = __webpack_public_path__ + "img/agpz-truck-default.42354744.svg";